<div [ngClass]="{'disabled': disabled ,'pre-load':preload}" class="preview-navigation d-flex align-items-center justify-content-start" (click)="NavigatetoNextPage()">
    <i class="fa fa-chevron-right" title="Next" aria-hidden="true"></i>
</div>